import config from '../../config';

import availabilitySetsComponentUrl from './availabilitySetsComponent.html';

class AvailabilitySetsCtrl {
  constructor(
    Authentication,
    AvailabilityUtils,
    ConfirmService,
    Restangular,
    $timeout,
    $state,
    $window
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AvailabilityUtils,
      ConfirmService,
      Restangular,
      $timeout,
      $state,
      $window,
    });
  }

  async $onChanges({ loading }) {
    if (loading && loading.currentValue === false && !this.animationsEnabled) {
      await this.$timeout(); // in order to get the initial sets rendered
      this.animationsEnabled = true;
    }
  }

  get addAvailabilityHidden() {
    if (this.singleSet) {
      return true;
    }

    if (!this.approvalEnabled) {
      return false;
    }

    return this.isEditing || !!this.availabilitySets.find((set) => !set.availabilityId);
  }

  get approvalEnabled() {
    return this.AvailabilityUtils.isApprovalEnabled();
  }

  get isEditing() {
    return this.AvailabilityUtils.isEditing(this.availabilitySets);
  }

  addSet(copyFromSet) {
    if (config.UNAVAILABILITY_LIST_V2_ENABLED) {
      this.$state.go('users.profile', {
        userId: this.srcUserId || this.Authentication.user.id,
        tab: 'availability',
        unavailabilityId: null,
        newSet: true,
        copySet: copyFromSet,
      });

      return;
    }

    this.availabilitySets.unshift(
      this.AvailabilityUtils.createAvailabilitySet(this.user, copyFromSet)
    );
    this.notifyChange();
  }

  async deleteSet(set) {
    try {
      const index = this.availabilitySets.indexOf(set);
      if (index >= 0) {
        if (set.availabilityId) {
          let question = 'Are you sure you want to delete this availability set?';

          if (!set.details?.approved && this.AvailabilityUtils.shouldRequest()) {
            question =
              "Canceling the unavailability request will remove it from your unavailability and won't be considered by your manager.";
          }

          await this.ConfirmService.ask(question);
          await this.AvailabilityUtils.deleteAvailabilitySet(set.availabilityId);
        }
        this.goBack?.();
        this.availabilitySets.splice(index, 1);
      }
    } catch (e) {
      if (!__TEST__) {
        console.log(e);
      }
    }
  }

  async rejectSet(set) {
    try {
      const index = this.availabilitySets.indexOf(set);
      if (index >= 0) {
        this.AvailabilityUtils.denyUnavailabilitySet(set);

        this.availabilitySets.splice(index, 1);
      }
    } catch (e) {
      if (!__TEST__) {
        console.log(e);
      }
    }
  }

  notifyChange() {
    if (this.form) {
      this.form.$setDirty();
    }
  }

  goToSchedule() {
    this.$state.go('shifts', {}, { reload: false });
  }
}

export default {
  bindings: {
    user: '<',
    availabilitySets: '<src',
    readOnly: '<',
    loading: '<',
    singleSet: '<',
    allSetsCount: '<',
    isEdittingSet: '<',
    hideHeader: '<',
    goback: '&?',
  },
  require: {
    form: '?^form',
  },
  controller: AvailabilitySetsCtrl,
  controllerAs: 'ctrl',
  templateUrl: availabilitySetsComponentUrl,
};
